import { fromJS } from 'immutable';
export var SET_TRAFFIC_LIVE_CHART_DATA = 'traffic-prediction/SET_TRAFFIC_LIVE_CHART_DATA';
export var SET_VDS_DATA = 'traffic-prediction/SET_VDS_DATA';
export var SET_VDS_SORT = 'traffic-prediction/SET_VDS_SORT';
export var SET_VDS_TOTAL_COUNT = 'traffic-prediction/SET_VDS_TOTAL_COUNT';
export var SET_TERMINALS_DATA = 'traffic-prediction/SET_TERMINALS_DATA';
export var SET_TERMINALS_SORT = 'traffic-prediction/SET_TERMINALS_SORT';
export var SET_TERMINALS_TOTAL_COUNT = 'traffic-prediction/SET_TERMINALS_TOTAL_COUNT';
export var SET_TERMINALS_CHART_DATA = 'traffic-prediction/SET_TERMINALS_CHART_DATA';
export var SET_GATES_DATA = 'traffic-prediction/SET_GATES_DATA';
export var SET_GATES_SORT = 'traffic-prediction/SET_GATES_PORT';
export var SET_GATES_TOTAL_COUNT = 'traffic-prediction/SET_GATES_TOTAL_COUNT';
export var SET_GATES_CHART_DATA = 'traffic-prediction/SET_GATES_CHART_DATA';
export var SET_MAP_BOUNDS = 'traffic-prediction/SET_MAP_BOUNDS';
export var SET_MARKER_LIST = 'traffic-prediction/SET_MARKER_LIST';
export var SET_EVENT_MARKER_LIST = 'traffic-prediction/SET_EVENT_MARKER_LIST';
export var SET_OPEN_DIALOG = 'traffic-prediction/SET_OPEN_DIALOG';
export var SET_DIALOG_CONTENT = 'traffic-prediction/SET_DIALOG_CONTENT';
export var SET_EVENT_TYPE_LIST = 'traffic-prediction/SET_EVENT_TYPE_LIST';
export var SET_SELECTED_AREA = 'traffic-prediction/SET_SELECTED_AREA';
export var SET_EVENT_TABLE_LIST = 'traffic-prediction/SET_EVENT_TABLE_LIST';
export var SET_EVENT_TABLE_SORT = 'traffic-prediction/SET_EVENT_TABLE_SORT';
export var SET_SHOW_FILTER_BLOCK = 'traffic-prediction/SET_SHOW_FILTER_BLOCK';
export var SET_SHOW_TABLE = 'traffic-prediction/SET_SHOW_TABLE';
export var RESET = 'traffic-prediction/RESET';
export var setTrafficLiveChartData = function setTrafficLiveChartData(data) {
  return {
    type: SET_TRAFFIC_LIVE_CHART_DATA,
    data: data
  };
};
export var setVdsData = function setVdsData(data) {
  return {
    type: SET_VDS_DATA,
    data: data
  };
};
export var setVdsSort = function setVdsSort(sort) {
  return {
    type: SET_VDS_SORT,
    sort: sort
  };
};
export var setVdsTotalCount = function setVdsTotalCount(data) {
  return {
    type: SET_VDS_TOTAL_COUNT,
    data: data
  };
};
export var setTerminalsData = function setTerminalsData(data) {
  return {
    type: SET_TERMINALS_DATA,
    data: data
  };
};
export var setTerminalsSort = function setTerminalsSort(sort) {
  return {
    type: SET_TERMINALS_SORT,
    sort: sort
  };
};
export var setTerminalsTotalCount = function setTerminalsTotalCount(data) {
  return {
    type: SET_TERMINALS_TOTAL_COUNT,
    data: data
  };
};
export var setTerminalsChartData = function setTerminalsChartData(data) {
  return {
    type: SET_TERMINALS_CHART_DATA,
    data: data
  };
};
export var setGatesData = function setGatesData(data) {
  return {
    type: SET_GATES_DATA,
    data: data
  };
};
export var setGatesSort = function setGatesSort(sort) {
  return {
    type: SET_GATES_SORT,
    sort: sort
  };
};
export var setGatesTotalCount = function setGatesTotalCount(data) {
  return {
    type: SET_GATES_TOTAL_COUNT,
    data: data
  };
};
export var setGatesChartData = function setGatesChartData(data) {
  return {
    type: SET_GATES_CHART_DATA,
    data: data
  };
};
export var setMapBounds = function setMapBounds(data) {
  return {
    type: SET_MAP_BOUNDS,
    data: data
  };
};
export var setMarkerList = function setMarkerList(data) {
  return {
    type: SET_MARKER_LIST,
    data: data
  };
};
export var setEventMarkerList = function setEventMarkerList(data) {
  return {
    type: SET_EVENT_MARKER_LIST,
    data: data
  };
};
export var setOepnDailog = function setOepnDailog(data) {
  return {
    type: SET_OPEN_DIALOG,
    data: data
  };
};
export var setDialogContent = function setDialogContent(data) {
  return {
    type: SET_DIALOG_CONTENT,
    data: data
  };
};
export var setEventTypeList = function setEventTypeList(data) {
  return {
    type: SET_EVENT_TYPE_LIST,
    data: data
  };
};
export var setSelectedArea = function setSelectedArea(data) {
  return {
    type: SET_SELECTED_AREA,
    data: data
  };
};
export var setEventTableSort = function setEventTableSort(sort) {
  return {
    type: SET_EVENT_TABLE_SORT,
    sort: sort
  };
};
export var setEventTableList = function setEventTableList(data) {
  return {
    type: SET_EVENT_TABLE_LIST,
    data: data
  };
};
export var setShowFilterBlock = function setShowFilterBlock(data) {
  return {
    type: SET_SHOW_FILTER_BLOCK,
    data: data
  };
};
export var setShowTable = function setShowTable(data) {
  return {
    type: SET_SHOW_TABLE,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initialState = fromJS({
  trafficLiveChartData: {},
  vdsData: [],
  vdsSort: {
    field: 'updatedAt',
    desc: true
  },
  vdsTotalCount: 0,
  terminalsData: [],
  terminalsSort: {
    field: 'updatedAt',
    desc: true
  },
  terminalsTotalCount: 0,
  terminalsChartData: {},
  gatesData: [],
  gatesSort: {
    field: 'defaultOrder',
    desc: true
  },
  gatesTotalCount: 0,
  gatesChartData: {},
  mapCenter: {},
  mapZoom: null,
  mapBounds: {},
  markerList: [],
  eventMarkerList: [],
  eventTypeList: [],
  eventTableSort: {
    field: 'beginTime',
    desc: true
  },
  eventTableList: [],
  selectedArea: {},
  openDialog: false,
  dialogContent: {},
  showFilterBlock: false,
  showTable: false
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_TRAFFIC_LIVE_CHART_DATA:
      return state.set('trafficLiveChartData', fromJS(action.data));

    case SET_VDS_DATA:
      return state.set('vdsData', fromJS(action.data));

    case SET_VDS_SORT:
      return state.set('vdsSort', fromJS(action.sort));

    case SET_VDS_TOTAL_COUNT:
      return state.set('vdsTotalCount', fromJS(action.data));

    case SET_TERMINALS_DATA:
      return state.set('terminalsData', fromJS(action.data));

    case SET_TERMINALS_SORT:
      return state.set('terminalsSort', fromJS(action.sort));

    case SET_TERMINALS_TOTAL_COUNT:
      return state.set('terminalsTotalCount', fromJS(action.data));

    case SET_TERMINALS_CHART_DATA:
      return state.set('terminalsChartData', fromJS(action.data));

    case SET_GATES_DATA:
      return state.set('gatesData', fromJS(action.data));

    case SET_GATES_SORT:
      return state.set('gatesSort', fromJS(action.sort));

    case SET_GATES_TOTAL_COUNT:
      return state.set('gatesTotalCount', fromJS(action.data));

    case SET_GATES_CHART_DATA:
      return state.set('gatesChartData', fromJS(action.data));

    case SET_MAP_BOUNDS:
      return state.set('mapBounds', fromJS(action.data));

    case SET_MARKER_LIST:
      return state.set('markerList', fromJS(action.data));

    case SET_EVENT_MARKER_LIST:
      return state.set('eventMarkerList', fromJS(action.data));

    case SET_OPEN_DIALOG:
      return state.set('openDialog', fromJS(action.data));

    case SET_DIALOG_CONTENT:
      return state.set('setDialogContent', fromJS(action.data));

    case SET_EVENT_TYPE_LIST:
      return state.set('eventTypeList', fromJS(action.data));

    case SET_SELECTED_AREA:
      return state.set('selectedArea', fromJS(action.data));

    case SET_EVENT_TABLE_SORT:
      return state.set('eventTableSort', fromJS(action.sort));

    case SET_EVENT_TABLE_LIST:
      return state.set('eventTableList', fromJS(action.data));

    case SET_SHOW_FILTER_BLOCK:
      return state.set('showFilterBlock', fromJS(action.data));

    case SET_SHOW_TABLE:
      return state.set('showTable', fromJS(action.data));

    case RESET:
      return initialState;

    default:
      return state;
  }
}